module.exports = __webpack_public_path__ + "img/torsten_frank.466ad548.jpg";